// ISDP CUSTOM: Entire file — Route refs for admin plugin.
// The admin surface is consolidated into four routed pages: Overview (root),
// Analytics (insights), Curation, and Access. The analytics/curation sub-views
// (Impact, Usage, AI / Content, Tech Radar, MCP) are tabs inside those pages, not
// their own routes, so they don't need route refs.
import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'admin',
});

export const insightsRouteRef = createRouteRef({
  id: 'admin-insights',
});

export const curationRouteRef = createRouteRef({
  id: 'admin-curation',
});

export const accessRouteRef = createRouteRef({
  id: 'admin-access',
});
